import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetHealthDateAuthorization} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {GetHealthDateAuthorization} from 'domain/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthDateAuthorization = (): GetHealthDateAuthorization =>
	new RemoteGetHealthDateAuthorization(
		makeBFFApiUrl(BookingFlowEndPoints.healthDateAuthorization),
		makeAuthorizeHttpClientDecorator(),
	);
